/* eslint-disable @typescript-eslint/no-explicit-any */
// useHistoryStackContext.tsx

import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, Location } from "react-router-dom";

interface HistoryStackContextType {
  history: Location<any>[];
  current: Location<any> | null;
  previous: Location<any> | null;
}

// eslint-disable-next-line react-refresh/only-export-components
const LocationHistoryStackContext = createContext<HistoryStackContextType>({
  history: [],
  previous: null,
  current: null,
});

export const LocationHistoryStackProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const location = useLocation();
  const [historyStack, setHistoryStack] = useState<Location<any>[]>([]);

  useEffect(() => {
    // Atualizar o histórico quando a localização mudars
    if (
      JSON.stringify({ ...location, key: "" }) !==
      JSON.stringify({ ...(historyStack[0] || {}), key: "" })
    ) {
      setHistoryStack((curr) => [location, ...curr.slice(0, 29)]);
    }
  }, [location]);

  const value = useMemo(() => {
    return {
      history: historyStack,
      previous: historyStack[1],
      current: historyStack[0],
    };
  }, [historyStack]);
  return (
    <LocationHistoryStackContext.Provider value={value}>
      {children}
    </LocationHistoryStackContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useLocationHistoryStack = () =>
  useContext(LocationHistoryStackContext);
